import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const cenv: ImportTypeConfig = {
  type: 'cenv',
}
